module.exports = __webpack_public_path__ + "img/Slice3-min.f32bd54d.png";